export default {
  "content": "<path d=\"M25.192 12.595l-.715-.715-1.41 1.418.004.004-2.295 2.295-5.38 5.395-3.63 3.631.698.7a1 1 0 001.415 0l4.95-4.95 7.54 7.54a1 1 0 001.414-1.414l-7.54-7.54 4.95-4.95a1 1 0 000-1.414zm-8.452-1.462L10.98 4.18l-6.93 6.931 6.959 5.764-1.491 1.494.045-.095-7.635-6.323a1 1 0 01-.07-1.478l8.486-8.485a1 1 0 011.477.07l6.324 7.634.066-.031-.164.165-1.305 1.307zm9.42-3.753l3.52-3.54c.4-.4.4-1.04 0-1.42-.2-.2-.46-.3-.72-.3-.24 0-.5.1-.7.3l-3.8 3.82-1.5 1.48-3.5 3.52-1.44 1.44-5.46 5.48-5.3 5.3-1.42 1.44-3.52 3.52a.99.99 0 000 1.42c.2.2.46.3.72.3.24 0 .5-.1.7-.3l3.8-3.8 1.48-1.5 4.96-4.96 5.46-5.48 1.44-1.44 3.84-3.86 1.44-1.42z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "33",
    "fill": "currentColor",
    "viewBox": "0 0 32 33"
  }
};